/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ app: NonNullable<unknown> }} Directory_Submit_Workspace_Score_NoteInputs */

const en_directory_submit_workspace_score_note = /** @type {(inputs: Directory_Submit_Workspace_Score_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AI Readiness and GEO Score are calculated by ${i?.app} after submission and cannot be edited here.`)
};

const zh_directory_submit_workspace_score_note = /** @type {(inputs: Directory_Submit_Workspace_Score_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AI 就绪度和 GEO Score 由 ${i?.app} 在提交后自动评估，不能在此编辑。`)
};

/**
* | output |
* | --- |
* | "AI Readiness and GEO Score are calculated by {app} after submission and cannot be edited here." |
*
* @param {Directory_Submit_Workspace_Score_NoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_workspace_score_note = /** @type {((inputs: Directory_Submit_Workspace_Score_NoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Workspace_Score_NoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_workspace_score_note(inputs)
	return zh_directory_submit_workspace_score_note(inputs)
});
export { directory_submit_workspace_score_note as "directory.submit.workspace.score_note" }